import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  component: App,
  loader: () => {
    throw redirect({ to: "/payments/domestic" });
  },
});

function App() {
  return <div>Dashboard</div>;
}
